import React from 'react';
import { Button } from '@economic/taco';
import { Trans } from '@lingui/macro';
import ExternalLink from '../../shared/components/ExternalLink';
import iconLearn from './iconLearn.svg';
import iconLightbulb from './iconLightbulb.svg';
import iconRead from './iconRead.svg';
import success from './onboarding_getstarted.png';

interface Props {
    onDone: () => void;
    isRackbeatStepVisible: boolean | undefined;
    isInterestedInRackbeat: boolean | undefined;
}

export default function StepSuccess({ onDone, isRackbeatStepVisible, isInterestedInRackbeat }: Props) {
    function getSuccessMessageContent() {
        if (!isRackbeatStepVisible) {
            return <Trans>Your account is set up and ready to be used.</Trans>;
        }

        if (isInterestedInRackbeat) {
            return <Trans>Your agreement is ready to use, and you will now be taken to Storage by Rackbeat.</Trans>;
        }

        return (
            <Trans>
                Your agreement is ready to use! Fill out the contact form in the new tab and you will be contacted. Don't see it?
                Click <ExternalLink href="https://www.e-conomic.dk/funktioner/lager-af-rackbeat#kontakt">here</ExternalLink>.
            </Trans>
        );
    }

    return (
        <div className="onboarding__container__fixed-size">
            <div className="onboarding onboarding__success">
                <img src={success} alt="" className="onboarding__picture" />

                <h2>
                    <Trans>Done!</Trans>
                </h2>

                <p>{getSuccessMessageContent()}</p>

                <Button appearance="primary" onClick={onDone}>
                    {isInterestedInRackbeat ? (
                        <Trans>Start e-conomic and go to Lager by Rackbeat</Trans>
                    ) : (
                        <Trans>Start e-conomic</Trans>
                    )}
                </Button>

                <div className="bottom-panel">
                    <div>
                        <img src={iconRead} alt="" className="mx-auto" />
                        <p className="text-center">
                            <Trans>
                                In&nbsp;<ExternalLink href="https://www.e-conomic.dk/support/e-copedia">e-copedia</ExternalLink>,
                                you can find helpful articles that take you through e-conomic features
                            </Trans>
                        </p>
                    </div>
                    <div>
                        <img src={iconLightbulb} alt="" className="mx-auto" />
                        <p className="text-center">
                            <Trans>
                                Get a great start!
                                <br />
                                Visit our&nbsp;
                                <ExternalLink href="https://www.e-conomic.dk/support/kom-godt-i-gang">
                                    ''get-started''
                                </ExternalLink>{' '}
                                universe
                            </Trans>
                        </p>
                    </div>
                    <div>
                        <img src={iconLearn} alt="" className="mx-auto" />
                        <p className="text-center">
                            <Trans>
                                Get a comprehensive introduction! Join a free&nbsp;
                                <ExternalLink href="https://www.e-conomic.dk/support/online-kurser">online</ExternalLink>&nbsp;
                                course
                            </Trans>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
